export default __webpack_public_path__ + "locales/ar-SA/RoomLogoCover.json?hash=f56ec986b557981785aa3eaffa2155f4";